"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createKeyedCache = createKeyedCache;
const zustand_1 = require("zustand");
const middleware_1 = require("zustand/middleware");
/**
 * 依查詢條件快取的資料（PM 工時／毛利／變更單、HR 報表／出勤摘要）：persist 讓切頁、重新整理時先顯示上次的資料再背景更新
 * undefined＝這個條件還沒抓過（顯示骨架）；只保留最近 12 組，避免 localStorage 無限長大
 * fallback：第一次就抓失敗時存入的值（例：存 []，畫面顯示「沒有記錄」而不是一直骨架）；已有快取時保留舊資料
 */
const MAX_KEYS = 12;
function createKeyedCache(name, fetcher, fallback) {
    const keyOf = (query) => JSON.stringify(query);
    const useStore = (0, zustand_1.create)()((0, middleware_1.persist)((set) => ({
        cache: {},
        order: [],
        fetch: async (query) => {
            const key = keyOf(query);
            try {
                const data = await fetcher(query);
                set(state => {
                    const order = [key, ...state.order.filter(k => k !== key)].slice(0, MAX_KEYS);
                    const cache = {};
                    for (const k of order)
                        cache[k] = k === key ? data : state.cache[k];
                    return { cache, order };
                });
            }
            catch (error) {
                console.error(`Failed to load ${name}:`, error);
                if (fallback !== undefined) {
                    set(state => (state.cache[key] ? state : { cache: { ...state.cache, [key]: fallback }, order: [key, ...state.order].slice(0, MAX_KEYS) }));
                }
            }
        },
    }), { name, partialize: (state) => ({ cache: state.cache, order: state.order }) }));
    /** 取得資料（undefined＝還沒抓過）與重抓函式；query 為 null 時不抓（例：非管理員不抓毛利、條件還沒準備好） */
    return (query) => {
        const key = query === null ? '' : keyOf(query);
        const data = useStore(state => (query === null ? undefined : state.cache[key]));
        const fetch = useStore(state => state.fetch);
        return { data, refetch: () => (query === null ? Promise.resolve() : fetch(query)), key };
    };
}
